import { createRoot } from 'react-dom/client'
import { App } from './App';
import * as Sentry from "@sentry/react"

Sentry.init({
	dsn: "https://d5171539f5e0365b141a6d5df2737894@o4509072121987072.ingest.de.sentry.io/4511540128841808",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	environment: process.env.REACT_APP_CARDAMOMO_ENV,
	ignoreErrors: [/Failed to load Stripe\.js/],
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<Sentry.ErrorBoundary><App /></Sentry.ErrorBoundary>)